// Suppliers Selectors
export const selectSuppliers = (state) => state.suppliers.suppliers;
export const selectSuppliersLoading = (state) =>
  state.suppliers.suppliers.loading;
export const selectSuppliersData = (state) => state.suppliers.suppliers.data;
export const selectSuppliersError = (state) => state.suppliers.suppliers.error;

export const selectSelectedSupplier = (state) =>
  state.suppliers.selectedSupplier;
export const selectSelectedSupplierLoading = (state) =>
  state.suppliers.selectedSupplier.loading;
export const selectSelectedSupplierData = (state) =>
  state.suppliers.selectedSupplier.data;

export const selectSupplierProducts = (state) =>
  state.suppliers.supplierProducts;
export const selectSupplierProductsLoading = (state) =>
  state.suppliers.supplierProducts.loading;
export const selectSupplierProductsData = (state) =>
  state.suppliers.supplierProducts.data;

export const selectSupplierSearchResults = (state) =>
  state.suppliers.searchResults;
export const selectSupplierSearchData = (state) =>
  state.suppliers.searchResults.data;
export const selectSupplierSearchTotalCount = (state) =>
  state.suppliers.searchResults.totalCount;
